import type {
  Option,
  IADatabaseConfigBaseState,
  IADataBaseConfigKeys
} from '@dfg/brahma-types';
import type { IAConfigAction } from './reducers/ia-database-config/iaDatabaseConfig.types';
import type {
  IADatabaseInfo,
  IAInfoDatabaseAction
} from './reducers/ia-info/iaInfo.types';

export type IAConfigData = {
  [IADataBaseConfigKeys.attributeType]: IADatabaseConfigBaseState<Option[]>;
  [IADataBaseConfigKeys.componentType]: IADatabaseConfigBaseState<Option[]>;
  [IADataBaseConfigKeys.documentType]: IADatabaseConfigBaseState<Option[]>;
};

export interface IADatabaseContextReducerState {
  iaInfo: IADatabaseInfo;
  configData: IAConfigData; // this will contain all data related to common config
}

export interface IaDatabaseManagementProviderProps {
  children: React.ReactNode;
  iaDatabase: IADatabaseContextReducerState;
}

export enum IaDatabaseActionTypesEnum {
  updateIaDatabase = 'UPDATE_IA_DATABASE',
  updateIaDatabaseConfig = 'UPDATE_IA_DATABASE_CONFIG',
  updateIaInfo = 'UPDATE_IA_INFO',
  updateIaOffices = 'UPDATE_IA_OFFICES',
  updateParticularIaOffice = 'UPDATE_PARTICULAR_IA_OFFICES',
  updateIaOfficeEntities = 'UPDATE_IA_OFFICE_ENTITIES',
  updateIaOfficeModalInfo = 'UPDATE_IA_OFFICE_MODAL_INFO'
}

// Define the action types
export type IaDataBaseAction = {
  type: IaDatabaseActionTypesEnum.updateIaDatabase;
  payload: IADatabaseContextReducerState;
};

export type IADatabaseAction =
  | IaDataBaseAction
  | IAConfigAction
  | IAInfoDatabaseAction;
